<template>
  <div v-if="content" v-editable="content" id="nous-trouver">
    <component :content="blok" :key="blok._uid" v-for="(blok) in content.body" :is="blok.component"></component>
  </div>
</template>

<script>
import api from "@/api";
export default {
  name: "blog",
  data() {
    return {
      content: null,
      id: this.$route.params.id
    };
  },
  created() {
    this.fetchData();
    if (this.$storyblok) {
      this.$storyblok.init();
      this.$storyblok.on(["change", "published"], () =>
        window.location.reload()
      );
      this.$storyblok.on("input", ({ story }) => {
        this.content = story.content;
      });
    }
  },
  methods: {
    async fetchData() {
      const res = await api.get(
        `cdn/stories/${this.$i18n.locale}/pages/nous-trouver/${this.id}`
      );

      this.content = res.data.story.content;
    }
  }
};
</script>